<template>
    <div>
        <c-search-form :rows-per-page-items="[10,20,50]"
                       :input-create-items="createItems"
                       :form-name="formName"
                       :fields="fields" accept-copy
                       :search-div="'searchDivRequest'"
                       :create-div="'createDivRequest'"
                       key-property="requestId"
                       search-url="/request/search"
                       create-url="/request/save"
                       delete-url="/request/delete"
                       form-type="intable"
                       @onCreateFile="onCreateFile"
                       ref="tableData"
        >
        </c-search-form>
        <!--FlowSelect ref="flowSelect"/-->
        <ProcedureSelect ref="procedureSelect" @select="onSelectProc"/>
        <v-container>
            <FileCreate :fileId="fileId"
                        id="createFileDiv"
                        style="display: none"
                        :request="request"
                        :default-data="file"
                        @save="saveSuccess"
                        @cancel="showMain"/>
        </v-container>
    </div>
</template>

<script>
    import CSearchForm from "../../../components/form/ManageForm";
    import axios from "axios";
    import FlowSelect from "../task/FlowSelect";
    import ProcedureSelect from "../procedure/ProcedureSelect";
    import FileCreate from "../../files/FileCreate";
    import VueI18n from "vue-i18n";
    import {router} from '../../../router';

    export default {
        name: 'request-management',
        components: {FileCreate, ProcedureSelect, FlowSelect, CSearchForm},
        data: () => {
            return {
                formName: "lang.request.title",
                createItems: [
                    {
                        type: "text",
                        name: "fromEmail",
                        label: "lang.request.fromEmail",
                        validate: "required",
                        maxlength: '500',
                        placeHolder: "",
                        focus: true
                    },
                    {
                        type: "text",
                        name: "subject",
                        label: "lang.request.subject",
                        validate: "required",
                        maxlength: '50',
                        placeHolder: "",
                        focus: true
                    },
                    {
                        type: "ckeditor",
                        name: "content",
                        label: "lang.request.content",
                        validate: "required",
                        maxlength: '2000',
                        placeHolder: "",
                    },
                    // {
                    //     type: "select",
                    //     name: "manageId",
                    //     label: "lang.request.manageId",
                    //     validate: "required",
                    //     itemText: "name",
                    //     itemValue: "id",
                    //     items: []
                    // },
                    {
                        type: "select",
                        name: "customerId",
                        label: "lang.request.customerId",
                        validate: "required",
                        itemText: "name",
                        itemValue: "id",
                        items: []
                    },
                    {
                        type: "text",
                        name: "customerRef",
                        label: "lang.request.customerRef",
                        placeHolder: ""
                    },

                ],
                fields: [
                    {
                        value: "index",
                        text: "lang.common.index",
                        width: "5%",
                        sortable: false,
                        headerStyle: "text-align:center"
                    },
                    {
                        value: 'fromEmail',
                        text: 'lang.request.fromEmail',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'subject',
                        text: 'lang.request.subject',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        type: "select",
                        items: [],
                        itemText: "name",
                        itemValue: "id",
                        name: 'customerId',
                        value: 'customerId',
                        text: 'lang.request.customerId',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        type: "upload",
                        value: 'attachIds',
                        text: 'lang.request.fileIds',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        type: "select",
                        name: "status",
                        value: 'status',
                        text: "lang.common.status",
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                        itemText: "status",
                        itemValue: "value",
                        items: [
                            {value: -1, status: router.app.$t("lang.request.deleted")},
                            {value: 1, status: router.app.$t("lang.request.waiting")},
                            {value: 2, status: router.app.$t("lang.request.assigned")},
                            {value: 3, status: router.app.$t("lang.request.filed")},
                            {value: 4, status: router.app.$t("lang.request.done")},
                        ],
                        render: (status) => {
                            switch (status) {
                                case -1:
                                    return "lang.request.deleted";
                                case 1:
                                    return "lang.request.waiting";
                                case 2:
                                    return "lang.request.assigned";
                                case 3:
                                    return "lang.request.filed";
                                case 4:
                                    return "lang.request.done";
                            }

                        }
                    },
                    {
                        value: 'custom_action',
                        text: "lang.request.createFile",
                        icon: "folder_shared",
                        event: "onCreateFile",
                        width: "10%",
                        color: "primary",
                        show: (data) => {
                            console.log(data);
                            if (data.status == 1) {
                                return true
                            } else {
                                return false;
                            }
                        },
                    },
                    {
                        value: 'action',
                        text: "lang.common.actions",
                        width: "20%",
                        sortable: false,
                        compound: true,
                        headerStyle: "text-align:center"
                    }
                ],
                selectProc: null,
                feeDlg: false,
                documentDlg: false,
                procedureId: null,
                request: null,
                file: null,
            }
        },
        created() {
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/user", {}).then(
                data => {
                    let item = this.createItems.filter(function (e) {
                        return e.name == "manageId";
                    });

                    item[0].items = data.items;
                    // let itemSearch = this.searchItems.filter(function(e) {
                    //     return e.name == "manageId";
                    // });
                    // itemSearch[0].items = data.items;
                    let itemFields = this.fields.filter(function (e) {
                        return e.name == "manageId";
                    });
                    itemFields[0].items = data.items;
                }
            )

            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/customer", {}).then(
                data => {
                    let item = this.createItems.filter(function (e) {
                        return e.name == "customerId";
                    });
                    if (item != undefined && item.length > 0) {
                        item[0].items = data.items;
                    }
                    let itemFields = this.fields.filter(function (e) {
                        return e.name == "customerId";
                    });
                    if (itemFields != undefined && itemFields.length > 0) {
                        itemFields[0].items = data.items;
                    }
                }
            )
        },

        methods: {
            onCreateFile(request) {
                this.$refs.procedureSelect.onShow(true);
                this.request = request;
            },


            onSelectProc(proc) {
                this.file = {
                    'procedureId': proc.procedureId,
                    'customerId': this.request.customerId
                };
                document.getElementById("searchDivRequest").style.display = "none";
                document.getElementById("createFileDiv").style.display = "";

            },

            saveSuccess(files) {
                this.request.fileId = files[fileId];
                axios.post(process.env.VUE_APP_API_URL + "/request/save", this.request).then(
                    data => {
                        if (data.success) {
                            this.$refs.tableData.search();
                        }
                    }
                )
            },

            showMain() {
                document.getElementById("searchDivRequest").style.display = "";
                document.getElementById("createFileDiv").style.display = "none";
            }

        },

        destroyed() {
        }
    }
</script>
